var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "17px",
    viewBox: "0 0 8 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "GFP-Imagery",
    transform: "translate(-469.000000, -429.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M476.855856,430.768377 C476.855856,431.805825 476.015015,433.008322 474.525526,433.008322 C473.492492,433.008322 472.723724,432.348128 472.723724,431.263523 C472.723724,430.226075 473.564565,429 475.03003,429 C476.087087,429 476.855856,429.683773 476.855856,430.768377 Z M475.606607,436.710125 C475.606607,438.619972 473.636637,442.10957 473.636637,443.335645 C473.636637,443.68932 473.828829,443.807212 474.069069,443.807212 C474.501502,443.807212 474.981982,443.382802 475.750751,441.520111 L477,441.944521 C476.039039,444.632455 474.573574,446 472.771772,446 C471.354354,446 470.321321,445.127601 470.321321,443.665742 C470.321321,441.732316 472.315315,438.266297 472.315315,437.0638 C472.315315,436.710125 472.171171,436.615811 471.954955,436.615811 C471.45045,436.615811 470.897898,437.535368 470.225225,438.950069 L469,438.478502 C470.105105,435.932039 471.426426,434.47018 473.324324,434.47018 C474.66967,434.47018 475.606607,435.366158 475.606607,436.710125 Z",
    id: "Info"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.fa9696bf159d777d8ff2961befdfea73.svg";
export { ForwardRef as ReactComponent };